
import { FileText } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

interface RelatedSummariesProps {
  summaries: any[];
}

const RelatedSummaries = ({ summaries }: RelatedSummariesProps) => {
  if (!summaries.length) return null;

  return (
    <div className="mb-6">
      <h3 className="font-semibold text-nation-blue mb-3 flex items-center text-sm">
        <FileText size={16} className="mr-2" />
        Related Document Summaries
      </h3>
      <div className="space-y-4">
        {summaries.map((summary, index) => (
          <Card key={index}>
            <CardContent className="pt-4">
              <h4 className="text-sm font-medium mb-2">{summary.title}</h4>
              <p className="text-sm text-muted-foreground mb-3">{summary.source}</p>
              {summary.external_url && (
                <Button variant="outline" size="sm" asChild className="mt-2">
                  <a href={summary.external_url} target="_blank" rel="noopener noreferrer">
                    <FileText size={14} className="mr-2" />
                    View Full Document
                  </a>
                </Button>
              )}
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default RelatedSummaries;
